<template>
  <EditorPriceDetails
    v-bind="{ convenienceFee, hasPromoCode, playCount, promotionTitle, salesTax, subtotal, total }"
  >
    <EditorPriceDetailsList
      v-if="currentPrice"
      v-bind="{ currentPrice, flaggedCount, isSubscription, lotteryId, prepaidSubscriptionAmount }"
    />
  </EditorPriceDetails>
</template>

<script lang="ts" setup>
import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

type Props = {
  lotteryId: LotteryId
}

const { lotteryId } = defineProps<Props>()

const {
  convenienceFee,
  currentPrice,
  flaggedCount,
  hasPromoCode,
  isSubscription,
  playCount,
  prepaidSubscriptionAmount,
  promotionTitle,
  salesTax,
  subtotal,
  total,
} = useEditorPriceDetails(lotteryId)
</script>
